// Milestone templates for different project types
export const MILESTONE_TEMPLATES = {
  'Digital Setup': [
    {
      title: 'Project Kickoff',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 0
    },
    {
      title: 'Account & Access Setup',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      description: 'Facebook, Instagram, Google Business Profile, basic tracking, etc.',
      order: 1
    },
    {
      title: 'Design Phase',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      description: 'Graphics, basic templates, page styling, etc.',
      order: 2
    },
    {
      title: 'Launch & Handoff',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 3
    }
  ],
  'Print & Promo': [
    {
      title: 'Project Kickoff',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 0
    },
    {
      title: 'Design Concepts',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 1
    },
    {
      title: 'Final Artwork Approval',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 2
    },
    {
      title: 'Production & Printing',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 3
    },
    {
      title: 'Delivery & Wrap-Up',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 4
    }
  ],
  'Offline Boost': [
    {
      title: 'Project Kickoff',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 0
    },
    {
      title: 'Design Concepts',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 1
    },
    {
      title: 'Final Artwork Approval',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 2
    },
    {
      title: 'Production & Printing',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 3
    },
    {
      title: 'Delivery & Wrap-Up',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 4
    }
  ],
  'Social Media Management': [
    {
      title: 'Project Kickoff',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 0
    },
    {
      title: 'Content & Brand Discovery',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 1
    },
    {
      title: 'Template & Asset Design',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 2
    },
    {
      title: 'Content Plan Handoff',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 3
    },
    {
      title: 'Final Review & Closeout',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 4
    }
  ],
  'Ad Push': [
    {
      title: 'Project Kickoff',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 0
    },
    {
      title: 'Content & Brand Discovery',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 1
    },
    {
      title: 'Template & Asset Design',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 2
    },
    {
      title: 'Content Plan Handoff',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 3
    },
    {
      title: 'Final Review & Closeout',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 4
    }
  ],
  'Fallback': [
    {
      title: 'Project Kickoff',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 0
    },
    {
      title: 'Design Phase',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 1
    },
    {
      title: 'Development',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 2
    },
    {
      title: 'Launch',
      status: 'planned',
      date_iso: null,
      target_date: 'No date set',
      order: 3
    }
  ]
};

// Helper to get milestone template for a project type
export const getMilestoneTemplate = (projectType) => {
  if (!projectType) return MILESTONE_TEMPLATES['Fallback'];
  
  // Try exact match
  if (MILESTONE_TEMPLATES[projectType]) {
    return MILESTONE_TEMPLATES[projectType];
  }
  
  // Try partial match (case-insensitive)
  const normalizedType = projectType.toLowerCase();
  
  if (normalizedType.includes('digital') || normalizedType.includes('setup')) {
    return MILESTONE_TEMPLATES['Digital Setup'];
  }
  if (normalizedType.includes('print') || normalizedType.includes('promo') || normalizedType.includes('offline')) {
    return MILESTONE_TEMPLATES['Print & Promo'];
  }
  if (normalizedType.includes('social') || normalizedType.includes('starter')) {
    return MILESTONE_TEMPLATES['Social Media Management'];
  }
  if (normalizedType.includes('ad')) {
    return MILESTONE_TEMPLATES['Ad Push'];
  }
  
  // Fallback
  return MILESTONE_TEMPLATES['Fallback'];
};
